import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=838a6014&"
import script from "./DefaultView.vue?vue&type=script&lang=js&"
export * from "./DefaultView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=838a6014&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports